module.exports = __webpack_public_path__ + "img/canvasMenuModifyShape.921a71d4.svg";